module.exports = __webpack_public_path__ + "img/1530663157.3ef720aa.jpg";